<template>
  <div class="app-container" v-loading="loading">
    <!-- 搜索栏 -->
    <el-form @submit.native.prevent :model="queryParams" :inline="true">
      <el-form-item label="">
        <el-input @keyup.enter="handleQuery" v-model="queryParams.projectNameORApprovalNumber" style="width: 200px" placeholder="项目名称/备案号" clearable />
      </el-form-item>
      <!-- <el-form-item label="">
        <el-select v-model="queryParams.qrCodeStatus" placeholder="全部状态">
          <el-option label="未生成" value="0"></el-option>
          <el-option label="已生成" value="1"></el-option>
          <el-option label="已张贴" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="queryParams.amountLevel" placeholder="全部金额范围">
          <el-option label="100w以下" :value="0"></el-option>
          <el-option label="100w以上" :value="1"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button type="info" icon="el-icon-search" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格展示 -->
    <el-table border :data="onlineList" class="data-table">
      <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
      <!-- 项目名称-->
      <el-table-column prop="projectName" label="项目名称" align="center"> </el-table-column>
      <!-- 项目负责人 -->
      <el-table-column prop="generalContractorContact" label="项目负责人" align="center"></el-table-column>
      <!-- 二维码 -->
      <el-table-column prop="qrCodeUrl" label="二维码" align="center">
        <template slot-scope="{ row }">
          <template v-if="!row.readonly">
            <el-image
                v-if="row.qrCodeUrl"
                style="width: 100px; height: 100px"
                :src=" imageUrlprefix 
                + row.qrCodeUrl"
                :preview-src-list="[imageUrlprefix + row.qrCodeUrl]"
                preview-teleported
            />
          </template>
          <template v-else>
            <img v-if="row.qrCodeUrl" :src="imageUrlprefix 
            + row.qrCodeUrl" alt="" style="width: 100px; height: 100px">
          </template>
        </template>
      </el-table-column>

      <!-- 二维码状态 -->
      <!-- <el-table-column prop="qrCodeStatus" label="二维码状态" align="center">
        <template #default="scope">
          <div class="create-time">
            <span v-if="scope.row.qrCodeStatus == 0" style="margin-left: 10px"
              >未生成</span
            >
            <span v-if="scope.row.qrCodeStatus == 1" style="margin-left: 10px"
              >已生成</span
            >
            <span v-if="scope.row.qrCodeStatus == 2" style="margin-left: 10px"
              >已张贴</span
            >
          </div>
        </template>
      </el-table-column> -->
      <!-- 生成时间 -->
      <el-table-column prop="qrCodeTime" label="生成时间" align="center"></el-table-column>
      <!-- 操作 -->
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
         <el-link
            v-if="scope.row.qrCodeUrl && !scope.row.readonly"
            type="primary"
            @click="handleDownload(imageUrlprefix + scope.row.qrCodeUrl, scope.row.projectName)"
          >下载</el-link>
          <!-- <el-button type="primary" link @click="assign(scope.row.id)"
            >打印</el-button
          >
          <el-button type="danger" link @click="handleView(scope.row)">
            查看记录
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination-wrapper">
      <pagination v-if="count > 0" :total="count" :page.sync="queryParams.current" :limit.sync="queryParams.size" @pagination="getList" />
    </div>
    <!-- 操作日志详细 -->
    <el-dialog title="查看详情" :visible.sync="open" width="80%" append-to-body>
      <el-form :model="exceptionLog" label-width="120px">
        <el-form-item label="项目名称：">
          {{ exceptionLog.module }}
        </el-form-item>
        <el-form-item label="项目负责人：">
          {{ exceptionLog.module }}
        </el-form-item>
        <el-form-item label="二维码：">
          {{ exceptionLog.module }}
        </el-form-item>
        <el-form-item label="二维码状态：">
          {{ exceptionLog.module }}
        </el-form-item>
        <el-form-item label="生成时间">
          {{ exceptionLog.module }}
        </el-form-item>
        <!--                <preview-code :code="exceptionLog.message" type="java"></preview-code>-->
      </el-form>
      <template slot="footer">
        <div class="dialog-footer">
          <el-button @click="open = false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getProjectInfoPage, } from '@/api/unpaidWages/monitor'
import { downloadImage } from '@/utils/common'

export default {
  name: 'CodeMonitor',
  data() {
    return {
      count: 0,
      open: false,
      loading: false,
      queryParams: {
        generalContractorContact: '',
        projectNameORApprovalNumber: '',
        current: 1,
        size: 10,
      },
      onlineList: [],
      logIdList: [],
      exceptionLog: {},
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 查看
    handleView(log) {
      this.exceptionLog = log
      this.open = true
    },
    reset() {
      this.queryParams.projectNameORApprovalNumber = ''
      this.handleQuery()
    },
    getList() {
      this.loading = true
      /**重新定义请求格式参数 */
      const queryParams = {
        query: {
          generalContractorContact: this.queryParams.generalContractorContact,
          projectNameORApprovalNumber: this.queryParams.projectNameORApprovalNumber,
        },
        pageNum: this.queryParams.current,
        pageSize: this.queryParams.size,
      }
      getProjectInfoPage(queryParams).then((res) => {
        // 接口返回 { code, msg, data }，分页数据在 data 里：rows、total、pageNum、pageSize
        const body = res.data != null ? res.data : res
        const data = body.data != null ? body.data : body
        this.onlineList = data.rows || []
        this.count = data.total ?? 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleDownload(url, projectName) {
      const time = new Date().getTime()
      downloadImage(url, projectName + time + '.png')
    },
    handleQuery() {
      this.queryParams.current = 1
      this.getList()
    }
  }
}
</script>

<style scoped>
/* 表格样式 - 设置最小高度和间距 */
.data-table {
  min-height: 400px;
  margin-top: 0;
  overflow: auto;
}

/* 确保表格容器有足够的高度 */
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 搜索栏样式 */
.el-form {
  margin-bottom: 20px;
}

/* 分页样式 */
.pagination-wrapper {
  margin-top: 20px;
}
</style>
